import { all } from "redux-saga/effects";

import { watchDeleteClass, watchFetchClass, watchPatchClass, watchRefreshClass } from "./watchers";

export function* classManagementSagas() {
  yield all([watchFetchClass(), watchRefreshClass(), watchPatchClass(), watchDeleteClass()]);
}
